/* eslint-disable react/display-name */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import 'react-tooltip/dist/react-tooltip.css'
import { useContext } from 'react'

import {
  SettingOutlined,
  QuestionCircleOutlined,
  SyncOutlined,
  CheckOutlined,
  DeleteOutlined,
  SearchOutlined,
  InfoOutlined,
  InfoCircleFilled,
  InfoCircleOutlined,
  CalendarFilled,
  PauseOutlined,
  StepForwardOutlined,
} from '@ant-design/icons'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  PageHeader,
  Radio,
  Row,
  Select,
  Skeleton,
  Space,
  Spin,
  Statistic,
  Switch,
  Table,
  Typography,
} from 'antd'
import { ColumnsType, ColumnType } from 'antd/es/table'
import { FilterConfirmProps } from 'antd/es/table/interface'
import { SortOrder } from 'antd/lib/table/interface'
import Title from 'antd/lib/typography/Title'
import DetalhesIcon from 'Assets/detalhes.svg'
import MacrosIcon from 'Assets/macro.svg'
import { SelectFieldAnt, SelectItemProps } from 'Components/Form/Select'
import ID_COMPONENTE from 'config/idComponente'
import MACRO_CODIGO from 'config/macroCodigo'
import MACRO_NOME from 'config/macroNome'
import TIPO_MACRO from 'config/tipoMacro'
import TIPO_USUARIO from 'config/tipoUsuario'
import { ApplicationContext } from 'Context'
import buscaAgendamentoMultiplo from 'Helpers/agendamentoMultiplo'
import arrays from 'Helpers/arrays'
import cookie from 'Helpers/cookie'
import Veiculos from 'Helpers/Veiculos'
import Claims from 'Hooks/usePermissions/Claims'
import usePermissions from 'Hooks/usePermissions/usePermissions'
import { IPerfil, Roles } from 'Models/auth'
import { Empresa } from 'Models/cadastros'
import IMensagem from 'Models/chat/IMensagem'
import {
  IArmazem,
  IMacro,
  IAgendaAction,
  ICandidato,
  IAgendamentoMultiplo,
  IAlertaTipo,
  IChegada,
} from 'Models/docas'
import IAgendamentoModoCompacto from 'Models/docas/IAgendamentoModoCompacto'
import IAlertaSonoro from 'Models/docas/IAlertaSonoro'
import IArmazemCota from 'Models/docas/IArmazemCota'
import IFormArmazemCotaFilter from 'Models/docas/IFormArmazemCotaFilter'
import IMacroCor from 'Models/docas/IMacroCor'
import moment from 'moment'
import env from 'react-dotenv'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
// import YouTube from 'react-youtube'
import { useSnackbar } from 'react-simple-snackbar'
import { Tooltip } from 'react-tooltip'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import handleToken from 'Services/handleToken'
import WsCadastroService from 'Services/WS_CADASTRO'
import WsDocasService from 'Services/WS_DOCAS'
import agenda from 'Services/WS_DOCAS/agenda'
import modoCompacto from 'Services/WS_DOCAS/modoCompacto'
import IFormDocasCandidatosFilter from 'Services/WS_DOCAS/types/resquest/IFormDocasCandidatosFilter'
import swal from 'sweetalert'
import { MsgSuccessOptions } from 'Types/SnackbarTypes'
import IFormEmpresasFilter from 'Views/Cadastros/Empresas/IFormEmpresasFilter'

import AlertaSonoroMP3 from '../../Assets/Sounds/beep.mp3'
import IHorario, { STATUS_HORARIOS } from '../../Models/docas/IHorario'
import Agenda from './Agenda'
import { DocasContext } from './Context/context'
import { DocasContextValue } from './Context/ContextType'
import ModalAjuda from './Modais/ModalAjuda'
import ModalBuscaPorPlaca from './Modais/ModalBuscaPorPlaca'
import ModalCandidatos from './Modais/ModalCandidatos'
import ModalConfiguracoes from './Modais/ModalConfiguracoes'
import ModalDetalhesCandidato from './Modais/ModalDetalhesCandidato'
import ModalImportarCandidatos from './Modais/ModalImportarCandidatos'
import ModalListaChegadas from './Modais/ModalListaChegadas'
import ModalLogs from './Modais/ModalLogs'
import ModalMacrosCandidato from './Modais/ModalMacrosCandidato'
import ModalPesquisaInclusaoMacros from './Modais/ModalPesquisaInclusaoMacros'
import ModalRemocaoCandidato from './Modais/ModalRemocaoCandidato'
import ModalStatusTransportadoras from './Modais/ModalStatusTransportadoras'
import ModoCompacto from './ModoCompacto'
import ModoCompactoAdamiBiomassa from './ModoCompactoAdamiBiomassa'
import ModoCompactoIraniFob from './ModoCompactoIraniFob'
interface DataType {
  key: React.Key
  Veiculo: string
}

const AgendamentoDocasIraniFob = (): ReactElement => {
  //const globalClasses = useGlobalStyles()
  const { Countdown } = Statistic
  const { Paragraph } = Typography

  const [updateTime] = useState<number>(
    window.parseInt(env.TEMPO_INICIAL_SEGUNDOS_CONTADOR_REGRESSIVO) * 1000,
  )

  const [tempoMsRequisicoesPlacasNaoCadastradas] = useState<number>(
    window.parseInt(env.TEMPO_SEGUNDOS_ENTRE_REQUISICOES_LISTA_CHEGADAS) * 1000,
  )

  const [urlPortalMisto, setUrlPortalMisto] = useState<string>('')

  const navigate = useNavigate()
  const hookForm = useForm()

  const { isAuthorized } = usePermissions()

  const { docasContext, setDocasContext } = useContext(DocasContext)
  const { applicationContext, setApplicationContext } =
    useContext(ApplicationContext)

  const [contadorPausado, setContadorPausado] = useState<boolean>(false)
  const [contadorPausadoAutomaticamente, setContadorPausadoAutomaticamente] =
    useState<boolean>(false)
  const [selectArmazemItens, setSelectArmazemItens] = useState<
    SelectItemProps[]
  >([])
  const [armazemNaoEncontrado, setArmazemNaoEncontrado] =
    useState<boolean>(false)
  const [armazemSelecionado, setArmazemSelecionado] = useState<number>()
  const [dataSelecionada, setDataSelecionada] = useState<moment.Moment>(
    applicationContext.dataPreSelecionada
      ? moment(applicationContext.dataPreSelecionada, 'YYYY-MM-DD')
      : moment(),
  )

  const [operacaoEmLoteSuccess, setOperacaoEmLoteSuccess] =
    useState<boolean>(false)
  const [loadingAgenda, setLoadingAgenda] = useState<boolean>(false)
  const [firstLoading, setFirstLoading] = useState<boolean>(true)

  //Controle de modais
  const [modalConfiguracoes, setModalConfiguracoes] = useState<boolean>(false)
  const [modalListaChegadas, setModalListaChegadas] = useState<boolean>(false)
  const [modalLogAcoes, setModalLogAcoes] = useState<boolean>(false)
  const [modalImportar, setModalImportar] = useState<boolean>(false)
  const [modalCandidatos, setModalCandidatos] = useState<boolean>(false)
  const [modalRemocaoCandidato, setModalRemocaoCandidato] =
    useState<boolean>(false)
  const [modalBuscaPorPlaca, setModalBuscaPorPlaca] = useState<boolean>(false)
  const [modalPesquisaInclusaoMacros, setModalPesquisaInclusaoMacros] =
    useState<boolean>(false)
  const [modalMacrosCandidato, setModalMacrosCandidato] =
    useState<boolean>(false)
  const [modalDetalhesCandidato, setModalDetalhesCandidato] =
    useState<boolean>(false)
  const [modalAjuda, setModalAjuda] = useState<boolean>(false)

  const [dataItens, setDataItens] = useState<ICandidato[]>()

  const [agendamentosModoCompacto, setAgendamentosModoCompacto] = useState<
    IAgendamentoModoCompacto[]
  >([])

  const [lastUpdate, setLastUpdate] = useState<number>()
  const [nextUpdate, setNextUpdate] = useState<number>()

  const [candidatoSelecionado, setCandidatoSelecionado] = useState<ICandidato>()

  const [updateMensagens, setUpdateMensagens] = useState<IMensagem[]>()
  const [updateMacros, setUpdateMacros] = useState<IMacro[]>()

  const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([])

  const [listaChegadas, setListaChegadas] = useState<IChegada[]>([])
  const [
    quantidadePlacasNaoCadastradasCompulog,
    setQuantidadePlacasNaoCadastradasCompulog,
  ] = useState<number>(0)

  const [alertaSonoro, setAlertaSonoro] = useState<HTMLAudioElement>(
    new Audio(AlertaSonoroMP3),
  )
  const [alertaSonoroAtivo, setAlertaSonoroAtivo] = useState<boolean>(false)

  const [liberandoAgenda, setLiberandoAgenda] = useState<boolean>(false)
  const [agendaLiberadaTotalmente, setAgendaLiberadaTotalmente] =
    useState<boolean>(true)

  const [
    mostrarMensagemArmazemPreSelecionado,
    setMostrarMensagemArmazemPreSelecionado,
  ] = useState<boolean>(true)

  const [openSnackbarSuccess, closeSnackbarSuccess] =
    useSnackbar(MsgSuccessOptions)

  const [atualizandoArmazemAgenda, setAtualizandoArmazemAgenda] =
    useState<boolean>(false)

  const [mostrarTooltip, setMostrarTooltip] = useState<boolean>(true)

  const [janelaPossuiLarguraIdeal, setJanelaPossuiLarguraIdeal] =
    useState<boolean>()

  const [voltarTelaInicial, setVoltarTelaInicial] = useState<boolean>(false)

  const verificaTransportadoraUsuario = () => {
    const cdsTransportadoras: number[] | undefined =
      applicationContext.usuarioAtual?.cdsTransportadoras

    return cdsTransportadoras?.length === 1 ? cdsTransportadoras[0] : undefined
  }

  const [cdTransportadoraUsuario] = useState<number | undefined>(
    verificaTransportadoraUsuario(),
  )

  const [selectTransportadoraItens, setSelectTransportadoraItens] = useState<
    SelectItemProps[]
  >([])

  const getTransportadoras = async () => {
    const filtros: IFormEmpresasFilter = {
      ativo: true,
    }

    const parametros: ParamsRequest = {
      pageSize: 10000,
      pageNumber: 1,
    }

    const { data } = await WsCadastroService.empresas.getList(
      ID_COMPONENTE.DOCAS,
      filtros,
      parametros,
    )

    if (data.items) {
      const selectTransportadorasData: SelectItemProps[] = data.items.map(
        (item: Empresa) => {
          return {
            value: item.id.toString(),
            label: item.nome,
          }
        },
      )

      setSelectTransportadoraItens(selectTransportadorasData)
    }
  }

  const verificaSeJanelaPossuiLarguraIdeal = () => {
    setJanelaPossuiLarguraIdeal(window.innerWidth >= 1679)
  }

  //const [alertaSonoroEvento, setAlertaSonoroEvento] = useState<any>()

  const geraResumoMacros = (macros: IMacro[]): string => {
    if (macros.length > 0) {
      let resumo = `${macros[0].nome} - ${macros[0].data} - ${macros[0].usuarioNome}`

      for (let i = 1; i < macros.length; i++) {
        resumo += `<br />${macros[i].nome} - ${macros[i].data} - ${macros[i].usuarioNome}`
      }

      return resumo
    } else {
      return 'Sem macros'
    }
  }

  const getItensData = async (filter: IFormDocasCandidatosFilter) => {
    if (
      isAuthorized(Claims.VerDetalhesTodasTransportadoras) ||
      filter.cdsTransportadoras ||
      applicationContext.usuarioAtual?.cdsTransportadoras
    ) {
      const localFilter: IFormDocasCandidatosFilter = {
        ...filter,
      }

      if (
        !isAuthorized(Claims.VerDetalhesTodasTransportadoras) &&
        !localFilter.cdsTransportadoras
      ) {
        localFilter.cdsTransportadoras =
          applicationContext.usuarioAtual!.cdsTransportadoras!
      }

      const { data } = await WsDocasService.candidatos.getList(
        ID_COMPONENTE.DOCAS,
        localFilter,
      )
      if (data.items) {
        setDataItens(data.items)
      }
    } else {
      //Se chegou até aqui, há um problema com o cadastro do usuário.
      //Se ele não pode ver os detalhes de todas as transportadoras,
      //e ao mesmo tempo não possui transportadoras vinculadas,
      //não é possível fazer uma requisição que garante a segurança dos dados.
      setDataItens([])
    }
  }

  // const verificaChegadasNaoCadastradas = async () => {
  //   try {
  //     const { data } =
  //       await WsDocasService.listaChegadas.contaChegadasNaoCadastradas(
  //         ID_COMPONENTE.DOCAS,
  //       )

  //     if (data.item && quantidadePlacasNaoCadastradasCompulog !== data.item) {
  //       setQuantidadePlacasNaoCadastradasCompulog(data.item)
  //     }
  //   } catch (e) {
  //     window.console.error(e)

  //     setQuantidadePlacasNaoCadastradasCompulog(0)
  //   }
  // }

  useEffect(() => {
    if (voltarTelaInicial) {
      window.location.href = urlPortalMisto
    }
  }, [voltarTelaInicial])

  useEffect(() => {
    if (!contadorPausado) {
      handleUpdate()
    }
  }, [contadorPausado])

  useEffect(() => {
    if (!modalMacrosCandidato) {
      setMostrarTooltip(false)
      window.setTimeout(() => setMostrarTooltip(true), 500)
    }
  }, [modalMacrosCandidato])

  useEffect(() => {
    if (alertaSonoroAtivo) {
      alertaSonoro.play()
    }
  }, [alertaSonoroAtivo])

  alertaSonoro.addEventListener('ended', () => {
    if (docasContext.alertasSonoros.some((s) => s.tocarSom)) {
      window.setTimeout(() => alertaSonoro.play(), 500)
    }
  })

  const getArmazens = async () => {
    const { data } = await WsDocasService.armazem.getList(ID_COMPONENTE.DOCAS, {
      data:
        docasContext.dataAtual?.format('YYYY-MM-DD') ||
        moment().format('YYYY-MM-DD'),
      apenasAtivos: true,
    })
    if (data.items) {
      const selectArmazensData: SelectItemProps[] = data.items
        .filter((x) => x.ativo)
        .map((item: IArmazem) => {
          return {
            value: item.cdAgendamentoDocasArmazem.toString(),
            label: item.nomeArmazem!,
          }
        })
      if (selectArmazensData && selectArmazensData.length) {
        setSelectArmazemItens(selectArmazensData)

        if (
          !armazemSelecionado &&
          !applicationContext.cdArmazemPreSelecionado
        ) {
          setArmazemSelecionado(parseInt(selectArmazensData[0].value))
        }
      } else {
        setArmazemNaoEncontrado(true)
        setFirstLoading(false)
      }
    }
  }

  const verificaUrlPortalMisto = () => {
    const cdEntidadeSistema: number | undefined =
      applicationContext.usuarioAtual?.cdEntidadeSistema

    if (cdEntidadeSistema) {
      setUrlPortalMisto(
        env[`URL_PORTAL_MISTO_ENTIDADE_SISTEMA_${cdEntidadeSistema}`],
      )
    }
  }

  useEffect(() => {
    verificaSeJanelaPossuiLarguraIdeal()
    window.addEventListener('resize', verificaSeJanelaPossuiLarguraIdeal)

    verificaUrlPortalMisto()

    //getArmazens()

    //Requisições assíncronas efetuadas assim que a pagina carregar
    Veiculos.get()

    if (!cdTransportadoraUsuario) {
      getTransportadoras()
    }
    //verificaChegadasNaoCadastradas()

    //Requisicoes assincronas a cada intervalo de tempo
    // const intervaloRequisicoesPlacasNaoCadastradas = window.setInterval(() => {
    //   verificaChegadasNaoCadastradas()
    // }, tempoMsRequisicoesPlacasNaoCadastradas)

    //Previne problemas na memoria RAM do usuario
    // return () => clearInterval(intervaloRequisicoesPlacasNaoCadastradas)
  }, [])

  useEffect(() => {
    getArmazens()

    setAtualizandoArmazemAgenda(true)

    getArmazensDetalhes()
  }, [docasContext.refreshArmazem, armazemSelecionado, dataSelecionada])

  const handleChangeArmazem = (value: string) => {
    if (applicationContext.cdArmazemPreSelecionado) {
      //Remove o armazém pré-selecionado do contexto para permitir a seleção de outros armazéns
      setApplicationContext({
        ...applicationContext,
        cdArmazemPreSelecionado: undefined,
        nomeArmazemPreSelecionado: undefined,
      })
    }

    const cdArmazemAtual = parseInt(value)

    setArmazemSelecionado(cdArmazemAtual)
  }

  const getArmazensDetalhes = async () => {
    if (armazemSelecionado && dataSelecionada) {
      try {
        const { data } = await WsDocasService.armazem.details(
          ID_COMPONENTE.DOCAS,
          armazemSelecionado,
          dataSelecionada.format('YYYY-MM-DD'),
        )

        if (data && data.items) {
          setDocasContext({
            ...docasContext,
            armazemAtual: data.items,
            dataAtual: dataSelecionada,
            cdArmazemAtual: armazemSelecionado,
          })
        }

        window.setTimeout(() => setAtualizandoArmazemAgenda(false), 1000)
      } catch (e) {
        console.error(e)

        //Se acontecer algum erro na busca dos detalhes dos armazéns, é necessário tentar de novo até que funcione
        window.setTimeout(() => getArmazensDetalhes(), 1000)
      }
    }
  }

  const getAgenda = async (
    cdArmazemAtual: number,
    limparSelecao?: boolean,
    executandoAcao?: boolean,
  ) => {
    if (docasContext.dataAtual) {
      const { data } = await WsDocasService.agenda.getList(
        ID_COMPONENTE.DOCAS,
        cdArmazemAtual,
        docasContext.dataAtual.format('YYYY-MM-DD'),
      )

      let macros: IMacro[] = docasContext.macros

      if (macros.length === 0) {
        const response = await WsDocasService.macro.getList(
          ID_COMPONENTE.DOCAS,
          armazemSelecionado,
        )

        if (response.data?.items) {
          macros = response.data.items
        }
      }

      let alertas: IAlertaTipo[] = docasContext.alertas

      if (alertas.length === 0) {
        const response = await WsDocasService.alerta.getListTipo(
          ID_COMPONENTE.DOCAS,
        )

        if (response.data?.items) {
          alertas = response.data.items
        }
      }

      const agendamentosMultiplos: IAgendamentoMultiplo[] = []
      const macrosParaAvisar: IMacroCor[] = []
      const alertasSonoros: IAlertaSonoro[] = docasContext.alertasSonoros

      if (data.items) {
        const horarios: IHorario[] = data.items
        let cdMacros: number[] = []

        if (macros) {
          const cdRoles: number[] | undefined =
            applicationContext.usuarioAtual?.perfis.map(
              (role: IPerfil): number => role.id,
            )

          if (cdRoles) {
            for (let i = 0; i < cdRoles.length; i++) {
              cdMacros = cdMacros.concat(
                macros
                  .filter((f) => f.listIdRolesNotificacao.includes(cdRoles[i]))
                  .map((macro: IMacro) => macro.cdMacro!),
              )
            }
          }

          for (let i = 0; i < horarios.length; i++) {
            if (horarios[i].placa) {
              const posicao: number = agendamentosMultiplos.findIndex(
                (f) =>
                  f.motorista === horarios[i].nomeMotorista &&
                  f.placa === horarios[i].placa &&
                  f.transportadora === horarios[i].nomeTransportadora,
              )

              if (posicao !== -1) {
                agendamentosMultiplos[posicao].horarios.push(horarios[i])
              } else {
                const macro: IMacro | undefined = horarios[i].temMacro
                  ? macros?.find((f) => f.cdMacro === horarios[i].cdMacro)
                  : undefined

                agendamentosMultiplos.push({
                  motorista: horarios[i].nomeMotorista,
                  placa: horarios[i].placa,
                  transportadora: horarios[i].nomeTransportadora,
                  horarios: [horarios[i]],
                  corMacro: macro?.corMacro,
                })
              }

              if (horarios[i].temMacro) {
                let macro: IMacro | undefined = macros.find(
                  (f) => f.cdMacro === horarios[i].cdMacro,
                )

                if (macro) {
                  if (macro.cdMacro === MACRO_CODIGO.OUTROS) {
                    const { data } = await WsDocasService.agenda.getDetalhes(
                      ID_COMPONENTE.DOCAS,
                      horarios[i].cdAgendamentoDocasHorario,
                    )

                    if (data?.data) {
                      const macros: IMacro[] = data.data.macrosCandidato

                      for (let i = macros.length - 1; i >= 0; i--) {
                        if (macros[i].cdMacro !== MACRO_CODIGO.OUTROS) {
                          macro = macros[i]
                          break
                        }
                      }
                    }
                  }

                  horarios[i].corMacro = macros.find(
                    (f) => f.cdMacro === macro?.cdMacro,
                  )?.corMacro

                  if (
                    cdMacros.some((s) => s === macro!.cdMacro) &&
                    !macrosParaAvisar.some((s) => s.cdMacro === macro!.cdMacro)
                  ) {
                    macrosParaAvisar.push({
                      cdMacro: macro.cdMacro!,
                      corMacro: macro.corMacro,
                    })
                  }
                }
              }

              if (posicao !== -1) {
                horarios[i].corMacro =
                  agendamentosMultiplos[posicao].horarios[0].corMacro
              }
            }
          }
        }

        const novoContext: DocasContextValue = {
          ...docasContext,
          horarios: horarios,
          totais: data.totais,
          macros: macros,
          macrosParaAvisar: macrosParaAvisar,
          agendamentosMultiplos: agendamentosMultiplos.filter(
            (f) => f.horarios.length > 1,
          ),
          alertas: alertas,
          alertasSonoros: alertasSonoros,
        }

        if (limparSelecao) {
          novoContext.selecionados = []
          novoContext.selecaoContinua = false
          novoContext.candidatoSelecionado = undefined
          novoContext.btnAprovarSelecionados = false
          novoContext.btnBloquearSelecionados = false

          setSelectedRowKeys([])
        }

        if (executandoAcao !== undefined) {
          novoContext.executing = executandoAcao
        }

        setDocasContext(novoContext)

        return horarios
      }
    }

    return undefined
  }

  const getArmazemAgenda = async (
    limparSelecao?: boolean,
    executandoAcao?: boolean,
  ) => {
    if (!agendaLiberadaTotalmente) {
      setAgendaLiberadaTotalmente(true)
    }

    const cdArmazemAtual: number | undefined =
      docasContext.cdArmazemAtual || armazemSelecionado

    if (docasContext.dataAtual && cdArmazemAtual) {
      const { data } = await WsDocasService.agenda.getList(
        ID_COMPONENTE.DOCAS,
        cdArmazemAtual,
        dataSelecionada.format('yyyy-MM-DD'),
      )

      const agendamentos: IAgendamentoModoCompacto[] = []

      if (data.items) {
        setDocasContext({ ...docasContext, horarios: data.items })

        for (let i = 0; i < data.items.length; i++) {
          const horario = data.items[i]

          if (
            horario.cdCandidatoAgendamento &&
            (!cdTransportadoraUsuario ||
              horario.cdEntidade === cdTransportadoraUsuario)
          ) {
            agendamentos.push({
              cdJanela: horario.cdAgendamentoDocasJanela,
              cdDoca: horario.cdAgendamendoDocasDocas,
              cdHorario: horario.cdAgendamentoDocasHorario,
              cdArmazem: cdArmazemAtual,
              cdCandidato: horario.cdCandidatoAgendamento,
              cdTransportadora: horario.cdEntidade,
              cdVeiculo: horario.cdVeiculo,
              cdViagem: horario.cdViagem,
              placa: horario.placa,
              nomeTransportadora: horario.nomeEntidade,
              nomeUsuario: horario.nomeUsuario!,
              janela: horario.nomeJanela,
              doca: horario.nomeDoca,
              horario: horario.hora.substring(0, 5),
              cdUltimaMacro: horario.cdMacro,
              nomeUltimaMacro: horario.nomeMacro,
              dtUltimaMacro: horario.dtHoraMacroStr,
              dadosViagem: horario.dadosViagem,
            })
          }
        }
      }

      setAgendamentosModoCompacto(agendamentos)
      setFirstLoading(false)
    }

    setLoadingAgenda(false)
    setContadorPausadoAutomaticamente(false)
    setLastUpdate(Date.now())
    setNextUpdate(Date.now() + updateTime)
  }

  useEffect(() => {
    setDocasContext({
      ...docasContext,
      candidatoSelecionado: undefined,
      selecionados: [],
      selecaoContinua: false,
    })
    setSelectedRowKeys([])

    handleUpdate(false, false)
  }, [docasContext.dataAtual, docasContext.cdArmazemAtual])

  const handleUpdate = async (
    limparSelecao?: boolean,
    executandoAcao?: boolean,
  ) => {
    if (!loadingAgenda && (armazemSelecionado || docasContext.cdArmazemAtual)) {
      setLoadingAgenda(true)

      await getArmazemAgenda(limparSelecao, executandoAcao)
    }
  }

  useEffect(() => {
    if (operacaoEmLoteSuccess) {
      setDocasContext({
        ...docasContext,
        selecionados: [],
        selecaoContinua: false,
        btnAprovarSelecionados: false,
        btnBloquearSelecionados: false,
      })
      setOperacaoEmLoteSuccess(false)
    }
  }, [operacaoEmLoteSuccess])

  // const desabilitaData = (data: moment.Moment) => {
  //   const dataAtual = moment().startOf('day')
  //   const dataLimite = dataAtual.add(3, 'day')

  //   return data.startOf('day') > dataLimite
  // }

  const handleChangeData = (data: any) => {
    setDataSelecionada(data)
    setContadorPausadoAutomaticamente(true)
  }

  const preparaModalRemocaoCandidato = async (candidato: ICandidato) => {
    setCandidatoSelecionado(candidato)
    setModalRemocaoCandidato(true)
  }

  const preparaModalMacrosCandidato = async (candidato: ICandidato) => {
    setCandidatoSelecionado(candidato)
    setModalMacrosCandidato(true)
  }

  const preparaModalDetalhesCandidato = async (candidato: ICandidato) => {
    setCandidatoSelecionado(candidato)
    setModalDetalhesCandidato(true)
  }

  const liberaAgendaDataAtual = async () => {
    setLiberandoAgenda(true)
    setAgendaLiberadaTotalmente(false)

    try {
      await WsDocasService.agenda.liberarAgenda(
        ID_COMPONENTE.DOCAS,
        armazemSelecionado!,
        dataSelecionada.format('YYYY-MM-DD'),
      )
    } catch (e) {
      console.log(e)

      alert('Ocorreu um erro para liberar a agenda, tente novamente')
    }

    if (!agendaLiberadaTotalmente) {
      await handleUpdate(false, false)
      setAgendaLiberadaTotalmente(true)
    }
  }

  const cancelaAgendamento = (cdCandidato: number) => {
    swal({
      title: 'Confirmar?',
      text: 'Tem certeza que deseja cancelar o agendamento?',
      icon: 'warning',
      buttons: ['NÃO', 'SIM'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const agendamentosParaCancelar: IAgendamentoModoCompacto[] = []
        const agendamentosRestantes: IAgendamentoModoCompacto[] = []

        for (let i = 0; i < agendamentosModoCompacto.length; i++) {
          if (agendamentosModoCompacto[i].cdCandidato === cdCandidato) {
            agendamentosParaCancelar.push(agendamentosModoCompacto[i])
          } else {
            agendamentosRestantes.push(agendamentosModoCompacto[i])
          }
        }

        const agendamentoMultiplo: boolean = agendamentosParaCancelar.length > 1

        WsDocasService.agenda.executaAcao(
          ID_COMPONENTE.DOCAS,
          agendamentosParaCancelar.map((agendamento) => {
            return {
              cdAgendamentoDocasHorario: agendamento.cdHorario,
              cdCandidatoAgendamento: agendamento.cdCandidato,
              placaVeiculo: agendamento.placa,
              transportadora: agendamento.nomeTransportadora,
              agendamentoMultiplo: agendamentoMultiplo,
              horarioStatus: STATUS_HORARIOS.CANCELADO,
            }
          }),
        )

        setAgendamentosModoCompacto(agendamentosRestantes)
      }
    })
  }
  // const preparaAvisoSonoro = (evento: any) => {
  //   setAlertaSonoroEvento(evento)
  // }

  // useEffect(() => {
  //   // if (alertaSonoroEvento) {
  //   //   alertaSonoroAtivo
  //   //     ? alertaSonoroEvento.target.playVideo()
  //   //     : alertaSonoroEvento.target.pauseVideo()
  //   // }
  // }, [alertaSonoroAtivo])

  const preSelecionaArmazem = () => {
    let cdArmazem: number | undefined

    if (applicationContext.nomeArmazemPreSelecionado) {
      if (applicationContext.cdArmazemPreSelecionado) {
        cdArmazem = applicationContext.cdArmazemPreSelecionado
      } else {
        const cdArmazemString = selectArmazemItens.find(
          (armazem) =>
            armazem.label === applicationContext.nomeArmazemPreSelecionado,
        )?.value

        if (cdArmazemString) {
          cdArmazem = window.parseInt(cdArmazemString)
        }
      }

      if (cdArmazem) {
        if (cdArmazem != armazemSelecionado) {
          setArmazemSelecionado(cdArmazem)
        }
      } else if (mostrarMensagemArmazemPreSelecionado) {
        openSnackbarSuccess(
          `O armazém com o nome ${applicationContext.nomeArmazemPreSelecionado} não está cadastrado. Se desejar cadastrar esse armazém, entre em contato com o suporte do Compulog.`,
        )

        setMostrarMensagemArmazemPreSelecionado(false)
      }

      //Remove o armazém pré-selecionado do contexto para permitir a seleção de outros armazéns
      // setApplicationContext({
      //   ...applicationContext,
      //   cdArmazemPreSelecionado: undefined,
      //   nomeArmazemPreSelecionado: undefined,
      // })
    }

    return (
      cdArmazem?.toString() || armazemSelecionado || selectArmazemItens[0].value
    )
  }

  const ordenaTextosOuNumeros = (
    item1?: string | number,
    item2?: string | number,
    ordem?: any,
  ) => {
    if (item1 && item2) {
      return item1 > item2 ? 1 : -1
    } else if (item1) {
      return ordem === 'ascend' ? -1 : 1
    } else if (item2) {
      return ordem === 'ascend' ? 1 : -1
    } else {
      return 0
    }
  }

  const ordenaDatas = (data1?: string, data2?: string, ordem?: any) => {
    if (data1 && data2) {
      const formato = 'DD/MM/YYYY HH:mm:ss'
      return moment(data1, formato).isAfter(moment(data2, formato)) ? 1 : -1
    } else if (data1) {
      return ordem === 'ascend' ? -1 : 1
    } else if (data2) {
      return ordem === 'ascend' ? 1 : -1
    } else {
      return 0
    }
  }

  const searchInput = useRef<any>(null)

  const aplicaFiltro = (confirm: (param?: FilterConfirmProps) => void) => {
    confirm({ closeDropdown: false })
  }

  const filtroPadrao = (dataIndex: any, title: string): ColumnType<any> => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Filtrar ${title}`}
          value={selectedKeys[0]}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : []),
              aplicaFiltro(confirm)
          }}
          style={{ marginBottom: 8, display: 'block' }}
        />
      </div>
    ),
    filterIcon: (filtered: boolean) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        .toLowerCase()
        .includes((value as string).toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100)
      }
    },
  })

  return (
    <Col>
      <Row justify="space-between">
        <div
          style={{
            fontWeight: 600,
            fontSize: '20px',
            color: 'rgba(0, 0, 0, 0.85)',
            zIndex: 1,
            position: janelaPossuiLarguraIdeal ? 'absolute' : 'relative',
            marginTop: janelaPossuiLarguraIdeal ? '4px' : '0px',
          }}
        >
          Gestão de Docas FOB
        </div>
        <PageHeader
          ghost={false}
          style={{ width: '100%', padding: 0, overflow: 'auto' }}
          extra={[
            <>
              {applicationContext.usuarioAtual?.mestreSistema && (
                <Button
                  type="primary"
                  key="1"
                  onClick={() => setModalConfiguracoes(true)}
                  disabled={firstLoading}
                >
                  <SettingOutlined />
                </Button>
              )}
            </>,
            <>
              {isAuthorized(Claims.ListaChegadas) &&
                applicationContext.usuarioAtual?.cdEntidadeSistema ===
                  298 /*Irani*/ && (
                  <Button
                    type="primary"
                    key="3"
                    onClick={() => {
                      setModalListaChegadas(true)
                    }}
                    disabled={firstLoading}
                    style={{ paddingRight: '12px' }}
                  >
                    Lista de Chegadas
                    <span
                      style={{
                        display:
                          quantidadePlacasNaoCadastradasCompulog > 0 &&
                          !firstLoading
                            ? 'inline'
                            : 'none',
                        backgroundColor: 'red',
                        borderRadius: '50%',
                        paddingBottom: '2px',
                        paddingRight: '6.5px',
                        paddingLeft: '6px',
                        marginLeft: '7px',
                        fontWeight: 'bold',
                      }}
                    >
                      {quantidadePlacasNaoCadastradasCompulog}
                    </span>
                  </Button>
                )}
            </>,
            <>
              {isAuthorized(Claims.LogAcoes) && (
                <Button
                  type="primary"
                  key="4"
                  onClick={() => {
                    setModalLogAcoes(true)
                  }}
                  disabled={firstLoading}
                >
                  Log de Ações
                </Button>
              )}
            </>,
            <>
              {isAuthorized(Claims.ImportarCandidatos) && (
                <Button
                  type="primary"
                  key="5"
                  onClick={() => {
                    setModalImportar(true)
                  }}
                  disabled={firstLoading}
                >
                  Importação de Candidatos
                </Button>
              )}
            </>,
            <>
              {isAuthorized(Claims.ImportarCandidatos) && (
                <Button
                  type="primary"
                  key="6"
                  onClick={() => {
                    setModalCandidatos(true)
                  }}
                  disabled={firstLoading}
                >
                  Cadastro de Candidatos
                </Button>
              )}
            </>,
            <>
              <Button
                type="primary"
                key="7"
                onClick={() => {
                  setModalBuscaPorPlaca(true)
                }}
                disabled={firstLoading}
              >
                Pesquisa de Agenda por Placa
              </Button>
            </>,
            <>
              {isAuthorized(Claims.Macro) && (
                <Button
                  type="primary"
                  key="8"
                  onClick={() => {
                    setModalPesquisaInclusaoMacros(true)
                  }}
                  disabled={firstLoading}
                >
                  Pesquisa/Inclusão de Macros
                </Button>
              )}
            </>,
            <>
              <Button
                type="primary"
                key="10"
                onClick={() => {
                  setApplicationContext({
                    ...applicationContext,
                    tempoSessaoMs: undefined,
                    dataInicioSessao: undefined,
                  })

                  setVoltarTelaInicial(true)
                }}
              >
                Voltar para a tela inicial
              </Button>
            </>,
            <Button
              type="primary"
              key="9"
              onClick={() => {
                setModalAjuda(true)
              }}
              disabled={firstLoading}
            >
              <QuestionCircleOutlined />
            </Button>,
          ]}
        />
      </Row>

      {armazemNaoEncontrado ? (
        <Row>
          <Col>
            <Title level={5}>Nenhum armazém encontrado</Title>
          </Col>
        </Row>
      ) : (
        <>
          <Row style={{ paddingTop: '10px' }}>
            <Col flex="auto">
              {selectArmazemItens.length ? (
                <Form
                  layout="vertical"
                  initialValues={{
                    data: dataSelecionada,
                    armazem: preSelecionaArmazem(),
                    handleChangeArmazem,
                  }}
                >
                  <Row align="bottom">
                    <Col span={6}>
                      <SelectFieldAnt
                        methods={hookForm}
                        scope="form-agenda-docas"
                        label="Selecione o Armazém:"
                        name="armazem"
                        items={selectArmazemItens}
                        onChangeValue={handleChangeArmazem}
                        disabled={firstLoading || atualizandoArmazemAgenda}
                      />
                    </Col>
                    <Col span={6}>
                      <Row gutter={32}>
                        <Col>
                          <Form.Item name="data" label="Data:">
                            <DatePicker
                              allowClear={false}
                              size="middle"
                              format="DD/MM/yyyy"
                              id="docas-input-data"
                              onChange={handleChangeData}
                              value={dataSelecionada}
                              disabled={
                                firstLoading || atualizandoArmazemAgenda
                              }
                              // disabledDate={desabilitaData}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Form>
              ) : (
                <Skeleton active />
              )}
            </Col>

            {firstLoading ? (
              <Col>
                <Skeleton active />
              </Col>
            ) : (
              <>
                <Col flex="30px"></Col>
                {loadingAgenda ? (
                  <Col flex="350px">
                    <Row
                      justify="center"
                      align="middle"
                      style={{ height: '100%', width: '100%' }}
                    >
                      <Col>
                        <Spin />
                      </Col>
                    </Row>
                  </Col>
                ) : (
                  <>
                    <Col flex="150px">
                      <Statistic
                        title="Última Atualização"
                        value={moment(lastUpdate).format('HH:mm:ss')}
                      />
                    </Col>
                    <Col flex="150px">
                      {contadorPausado ? (
                        <div
                          style={{
                            marginTop: '21px',
                            fontSize: '18px',
                            marginLeft: '-1px',
                            color: '#15b999',
                            fontWeight: 500,
                          }}
                        >
                          Contador pausado
                        </div>
                      ) : contadorPausadoAutomaticamente ? (
                        <div style={{ marginTop: '25px', marginLeft: '39px' }}>
                          <Spin />
                        </div>
                      ) : (
                        <Countdown
                          title="Próxima atualização"
                          value={nextUpdate}
                          onFinish={handleUpdate}
                        />
                      )}
                    </Col>
                    <Col flex="50px">
                      <Row align="middle" style={{ height: '100%' }}>
                        <Button
                          type="link"
                          disabled={docasContext.executing}
                          size="large"
                          icon={
                            contadorPausado ? (
                              <StepForwardOutlined
                                style={{ fontSize: '30px' }}
                              />
                            ) : (
                              <PauseOutlined style={{ fontSize: '30px' }} />
                            )
                          }
                          onClick={() => setContadorPausado(!contadorPausado)}
                        />
                      </Row>
                    </Col>
                    <Col flex="50px">
                      <Row align="middle" style={{ height: '100%' }}>
                        <Button
                          type="link"
                          disabled={docasContext.executing}
                          size="large"
                          icon={<SyncOutlined style={{ fontSize: '30px' }} />}
                          onClick={() => handleUpdate()}
                        />
                      </Row>
                    </Col>
                  </>
                )}
              </>
            )}
          </Row>

          {docasContext.horarios?.length && !firstLoading ? (
            <div
              style={{
                fontWeight: 'bold',
                fontSize: '22px',
                marginTop: '5px',
                marginBottom: '15px',
                textAlign: 'center',
              }}
            >
              {contadorPausadoAutomaticamente ? (
                <Spin />
              ) : (
                <div>AGENDA DO DIA {dataSelecionada.format('DD/MM/YYYY')}</div>
              )}
            </div>
          ) : null}

          <Row justify="space-between">
            {loadingAgenda && !lastUpdate ? (
              <Skeleton active />
            ) : (
              <>
                {docasContext.horarios?.length && docasContext.armazemAtual ? (
                  <Col flex="auto">
                    <Row>
                      <ModoCompactoIraniFob
                        armazem={docasContext.armazemAtual}
                        agendamentos={agendamentosModoCompacto}
                        selectTransportadoraItens={selectTransportadoraItens}
                        cdTransportadoraUsuario={cdTransportadoraUsuario}
                        atualizaAgenda={handleUpdate}
                      />
                    </Row>
                  </Col>
                ) : liberandoAgenda ? (
                  <Title level={5}>Liberando agenda...</Title>
                ) : (
                  <Skeleton loading={!lastUpdate} active>
                    <Title level={5}>
                      Ainda não foi liberada a agenda deste dia para este
                      armazem!
                      <br />
                      {isAuthorized(Claims.LiberarHorario) && (
                        <a onClick={() => liberaAgendaDataAtual()}>
                          Clique aqui para liberar a agenda para a data atual
                        </a>
                      )}
                    </Title>
                  </Skeleton>
                )}
              </>
            )}
          </Row>

          <Row>
            {agendamentosModoCompacto.length > 0 ? (
              <Col flex="auto">
                <Row>
                  <Title level={5}>Agendamentos:</Title>
                </Row>
                <Row>
                  <Table
                    style={{ width: '100%' }}
                    size="small"
                    pagination={false}
                    scroll={{ x: '100%' }}
                    columns={[
                      {
                        title: '',
                        key: 'cdCandidato',
                        dataIndex: 'cdCandidato',
                        width: '80px',
                        render: (
                          cdCandidato: number,
                          agendamento: IAgendamentoModoCompacto,
                        ) => (
                          <>
                            {isAuthorized(Claims.CancelarHorario) && (
                              <span
                                style={{
                                  cursor: 'pointer',
                                  marginLeft: '13px',
                                }}
                                title="Cancelar"
                                onClick={() =>
                                  cancelaAgendamento(agendamento.cdCandidato)
                                }
                              >
                                <DeleteOutlined />
                              </span>
                            )}

                            {isAuthorized(Claims.Macro) && (
                              <Button
                                id={`macros${cdCandidato}`}
                                type="link"
                                onClick={() =>
                                  preparaModalMacrosCandidato({
                                    cdCandidatoAgendamento:
                                      agendamento.cdCandidato,
                                    cdAgendamentoDocasArmazem:
                                      agendamento.cdArmazem,
                                    cdEntidade: agendamento.cdTransportadora,
                                    cdVeiculo: agendamento.cdVeiculo,
                                    cdViagem: agendamento.cdViagem,
                                    placa: agendamento.placa,
                                    nomeTransportadora:
                                      agendamento.nomeTransportadora,
                                  })
                                }
                                icon={
                                  <img
                                    style={{
                                      width: '17px',
                                      marginRight: '5px',
                                      marginBottom: '3px',
                                    }}
                                    src={MacrosIcon}
                                  />
                                }
                              />
                            )}
                          </>
                        ),
                      },
                      {
                        title: 'Veículo',
                        key: 'placa',
                        dataIndex: 'placa',
                        ...filtroPadrao('placa', 'Veículo'),
                        sorter: (a, b, ordem) =>
                          ordenaTextosOuNumeros(a.placa, b.placa, ordem),
                      },
                      {
                        title: 'Transportadora',
                        key: 'nomeTransportadora',
                        dataIndex: 'nomeTransportadora',
                        ...filtroPadrao('nomeTransportadora', 'Transportadora'),
                        sorter: (a, b, ordem) =>
                          ordenaTextosOuNumeros(
                            a.nomeTransportadora,
                            b.nomeTransportadora,
                            ordem,
                          ),
                      },
                      {
                        title: 'Doca',
                        key: 'doca',
                        dataIndex: 'doca',
                        ...filtroPadrao('doca', 'Doca'),
                        sorter: (a, b, ordem) =>
                          ordenaTextosOuNumeros(a.doca, b.doca, ordem),
                      },
                      {
                        title: 'Janela',
                        key: 'janela',
                        dataIndex: 'janela',
                        ...filtroPadrao('janela', 'Janela'),
                        sorter: (a, b, ordem) =>
                          ordenaTextosOuNumeros(a.janela, b.janela, ordem),
                      },
                      {
                        title: 'Horário',
                        key: 'horario',
                        dataIndex: 'horario',
                        ...filtroPadrao('horario', 'Horário'),
                        sorter: (a, b, ordem) =>
                          ordenaTextosOuNumeros(a.horario, b.horario, ordem),
                      },
                      {
                        title: 'Usuário',
                        key: 'nomeUsuario',
                        dataIndex: 'nomeUsuario',
                        ...filtroPadrao('nomeUsuario', 'Usuário'),
                        sorter: (a, b, ordem) =>
                          ordenaTextosOuNumeros(
                            a.nomeUsuario,
                            b.nomeUsuario,
                            ordem,
                          ),
                      },
                    ]}
                    dataSource={agendamentosModoCompacto.map((agendamento) => ({
                      ...agendamento,
                      key: agendamento.cdHorario.toString(),
                    }))}
                  />
                </Row>
              </Col>
            ) : (
              <>
                {firstLoading ? (
                  <Skeleton active />
                ) : (
                  <Title level={5}>
                    Nenhum agendamento registrado para este armazem neste dia!
                  </Title>
                )}
              </>
            )}
          </Row>
        </>
      )}
      <Modal
        centered
        visible={
          modalConfiguracoes ||
          modalListaChegadas ||
          modalLogAcoes ||
          modalImportar ||
          modalCandidatos ||
          modalRemocaoCandidato ||
          modalBuscaPorPlaca ||
          modalPesquisaInclusaoMacros ||
          modalMacrosCandidato ||
          modalDetalhesCandidato ||
          modalAjuda
        }
        onCancel={() => {
          modalConfiguracoes && setModalConfiguracoes(false)
          modalListaChegadas && setModalListaChegadas(false)
          modalLogAcoes && setModalLogAcoes(false)
          modalImportar && setModalImportar(false)
          modalCandidatos && setModalCandidatos(false)
          modalRemocaoCandidato && setModalRemocaoCandidato(false)
          modalBuscaPorPlaca && setModalBuscaPorPlaca(false)
          modalPesquisaInclusaoMacros && setModalPesquisaInclusaoMacros(false)
          modalMacrosCandidato && setModalMacrosCandidato(false)
          modalDetalhesCandidato && setModalDetalhesCandidato(false)
          modalAjuda && setModalAjuda(false)
        }}
        footer={[]}
        destroyOnClose={true}
        width={1350}
      >
        <div
          style={{
            maxHeight: '780px',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          {modalConfiguracoes && <ModalConfiguracoes />}

          {modalListaChegadas && (
            <ModalListaChegadas
              listaChegadas={listaChegadas}
              setListaChegadas={setListaChegadas}
            />
          )}

          {modalLogAcoes && <ModalLogs />}

          {modalImportar && (
            <ModalImportarCandidatos
              handleClose={() => setModalImportar(false)}
              atualizaAgenda={handleUpdate}
            />
          )}

          {modalCandidatos && (
            <ModalCandidatos
              setModal={setModalCandidatos}
              updateGridCandidatos={handleUpdate}
            />
          )}

          {modalRemocaoCandidato && (
            <ModalRemocaoCandidato
              id={candidatoSelecionado?.cdCandidatoAgendamento}
              nome={candidatoSelecionado?.nome}
              candidatos={dataItens}
              setCandidatos={setDataItens}
              setModal={setModalRemocaoCandidato}
            />
          )}

          {modalBuscaPorPlaca && <ModalBuscaPorPlaca />}

          {modalPesquisaInclusaoMacros && (
            <ModalPesquisaInclusaoMacros atualizaAgenda={handleUpdate} />
          )}

          {modalMacrosCandidato && (
            <ModalMacrosCandidato
              candidato={candidatoSelecionado}
              atualizaAgenda={handleUpdate}
            />
          )}

          {modalDetalhesCandidato && (
            <ModalDetalhesCandidato candidato={candidatoSelecionado} />
          )}

          {modalAjuda && <ModalAjuda />}
        </div>
      </Modal>

      {/* <div style={{ display: 'none' }}>
        <YouTube videoId="IdVfPhT1lBQ" onReady={preparaAvisoSonoro} />
      </div> */}
    </Col>
  )
}

export default AgendamentoDocasIraniFob
